import { StripeTokenResponse } from "components/StripePaymentForm/StripePaymentForm";
import {
  AccountDetails,
  BillingInterval,
  SignupChargeDetails,
  SubscriptionSource,
} from "features/types";
import qs from "qs";
import { CreateMemberPlanPackageParam } from "queries/account.queries";
import { get, post } from "./http";
import { SignupChargeRequest } from "./types";

const BASE = "accounts";

export interface CreateAccountRequest {
  type: "FULL" | "ASSOCIATE";
  primaryUser: {
    userId: number;
    createMemberPlanPackageParams: CreateMemberPlanPackageParam[];
  };
  members?: any[];
  token?: StripeTokenResponse | undefined;
  billingInterval?: BillingInterval;
  marketplace?: boolean;
  source: SubscriptionSource;
  salesRepId?: number;
}
class AccountService {
  signupCharge(params: SignupChargeRequest) {
    return get({
      method: "get",
      url: `${BASE}/signup_charge`,
      params,
      paramsSerializer: (params: any) => qs.stringify(params),
    }) as Promise<SignupChargeDetails>;
  }

  createAccount(params: CreateAccountRequest) {
    const { token } = params;
    return post({
      method: "post",
      url: BASE,
      params: {
        billingToken: token?.token.id,
        billingNameOnCard: token?.nameOnCard,
        billingAddress: "",
        billingAddressLine2: "",
        billingCity: "",
        billingState: "",
        billingPostalCode: token?.postalCode,
        billingCountry: "",
        ...params,
      },
    }) as Promise<AccountDetails>;
  }
}

export default new AccountService();
